import React from 'react';

const C = {
  trasporto: '#EB1C24',
  alloggio:  '#0071BA',
  attivita:  '#FF5B00',
  servizi:   '#009045',
  dark:      '#0a1628',
  white:     '#ffffff',
  text:      '#1a1a2e',
  textLight: '#6b7280',
  border:    '#e0e4ea',
};

const MOBILE_CSS = `
  .pktp-row { display: grid; grid-template-columns: 1fr 1fr; }
  @media (max-width: 600px) {
    .pktp-row { grid-template-columns: 1fr !important; }
    .pktp-logo { display: none !important; }
    .pktp-cell-tl { border-right: none !important; }
    .pktp-cell-bl { border-right: none !important; border-bottom: 2px solid #e0e4ea !important; }
    .pktp-header { padding: 10px 10px !important; gap: 6px !important; }
    .pktp-header-title { font-size: 20px !important; }
    .pktp-header-price { font-size: 15px !important; }
    .pktp-header-meta { font-size: 12px !important; }
    .pktp-header-sub { font-size: 10px !important; }
    .pktp-cell { padding: 7px 8px !important; }
    .pktp-seglabel { margin-bottom: 8px !important; }
    .pktp-seglabel-icon { height: 14px !important; }
    .pktp-seglabel-text { font-size: 11px !important; }
    .pktp-volo-badge-row { margin-bottom: 3px !important; }
    .pktp-volo-time { font-size: 13px !important; }
    .pktp-volo-city { font-size: 10px !important; }
    .pktp-volo-mid { font-size: 10px !important; }
    .pktp-volo-price { font-size: 13px !important; }
    .pktp-volo-gap { height: 5px !important; }
    .pktp-alloggio-head { margin-bottom: 5px !important; }
    .pktp-alloggio-title { font-size: 13px !important; }
    .pktp-alloggio-meta { font-size: 11px !important; }
    .pktp-alloggio-price { font-size: 13px !important; }
    .pktp-features { gap: 3px 8px !important; margin-top: 5px !important; padding-top: 5px !important; }
    .pktp-feature-text { font-size: 11px !important; }
    .pktp-list-row { padding: 3px 0 !important; }
    .pktp-list-text { font-size: 12px !important; }
    .pktp-list-price { font-size: 13px !important; }
    .pktp-footer { padding: 7px 12px !important; }
    .pktp-footer-pct { font-size: 15px !important; }
    .pktp-footer-text { font-size: 12px !important; }
  }
`;

export default function PacchettoCardParigi() {
  return (
    <div style={{ backgroundColor: C.white, borderRadius: '16px', overflow: 'hidden', border: `1px solid ${C.border}`, boxShadow: '0 4px 24px rgba(0,0,0,0.10)', fontFamily: 'Roboto, sans-serif', textAlign: 'left' }}>
      <style>{MOBILE_CSS}</style>

      {/* HEADER */}
      <div className="pktp-header" style={{ backgroundColor: C.dark, padding: '20px 28px', display: 'flex', alignItems: 'center', gap: '20px', justifyContent: 'space-between', flexWrap: 'wrap' }}>
        <span className="pktp-header-title" style={{ fontSize: '34px', fontWeight: 900, color: C.white, letterSpacing: '0.06em', textTransform: 'uppercase', lineHeight: 1 }}>PARIGI</span>
        <span className="pktp-header-meta" style={{ fontSize: '16px', color: 'rgba(255,255,255,0.7)', fontWeight: 500 }}>5 notti &nbsp;·&nbsp; 2 adulti</span>
        <div style={{ textAlign: 'right' }}>
          <div className="pktp-header-price" style={{ fontSize: '26px', fontWeight: 900, color: C.white, lineHeight: 1 }}>€ 750,00 <span style={{ fontSize: '13px', fontWeight: 400 }}>/ cad.</span></div>
          <div className="pktp-header-sub" style={{ fontSize: '12px', color: 'rgba(255,255,255,0.5)', marginTop: '3px' }}>spesa indicativa</div>
        </div>
      </div>

      {/* 2x2 GRID */}
      <div>

        {/* RIGA 1: Trasporto + Alloggio */}
        <div className="pktp-row" style={{ position: 'relative' }}>

          <div className="pktp-logo" style={{
            position: 'absolute', bottom: '-25px', left: '50%',
            transform: 'translateX(-50%)', zIndex: 10,
            backgroundColor: C.white, borderRadius: '50%',
            width: '50px', height: '50px',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            boxShadow: '0 2px 10px rgba(0,0,0,0.13)',
            border: `2px solid ${C.border}`,
          }}>
            <img src="/images/logo_mondo.svg" alt="OCTA" style={{ width: '30px', height: '30px', objectFit: 'contain' }} />
          </div>

          {/* TRASPORTO */}
          <div className="pktp-cell pktp-cell-tl" style={{ padding: '14px 16px', borderRight: `2px solid ${C.border}`, borderBottom: `2px solid ${C.border}` }}>
            <SegLabel colore={C.trasporto} img="/images/trasporto_icona.png" label="TRASPORTO" />
            <VologRow direz="Andata" oraPart="06.45" cittaPart="VERONA" durata="1h 45m" tipo="diretto" oraArr="08.30" cittaArr="PARIGI CDG" prezzo="€ 165,00" colore={C.trasporto} />
            <div className="pktp-volo-gap" style={{ height: '10px' }} />
            <VologRow direz="Ritorno" oraPart="21.15" cittaPart="PARIGI CDG" durata="1h 45m" tipo="diretto" oraArr="23.00" cittaArr="VERONA" prezzo="€ 165,00" colore={C.trasporto} />
          </div>

          {/* ALLOGGIO */}
          <div className="pktp-cell" style={{ padding: '14px 16px', borderBottom: `2px solid ${C.border}` }}>
            <SegLabel colore={C.alloggio} img="/images/alloggio_icona.png" label="ALLOGGIO" />
            <div className="pktp-alloggio-head" style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: '10px', marginBottom: '8px' }}>
              <div>
                <div className="pktp-alloggio-title" style={{ fontSize: '17px', fontWeight: 900, fontStyle: 'italic', color: C.text }}>HOTEL MERCURE BASTILLE<span style={{ color: '#f59e0b' }}>★★★★</span></div>
                <div className="pktp-alloggio-meta" style={{ fontSize: '13px', color: C.text, marginTop: '3px' }}>camera doppia classic · aria cond · 24 m²</div>
                <div className="pktp-alloggio-meta" style={{ fontSize: '13px', color: C.text }}>colazione inclusa · cassaforte in camera</div>
              </div>
              <div style={{ textAlign: 'right', flexShrink: 0 }}>
                <div className="pktp-alloggio-price" style={{ fontSize: '17px', fontWeight: 900, color: C.text }}>€ 550,00</div>
                <div style={{ marginTop: '4px', display: 'inline-flex', alignItems: 'center', gap: '4px', backgroundColor: '#e8f5e9', borderRadius: '5px', padding: '3px 6px' }}>
                  <span style={{ fontSize: '11px', fontWeight: 700, color: C.servizi, textTransform: 'uppercase' }}>OTTIMA</span>
                  <span style={{ fontSize: '13px', fontWeight: 900, color: C.white, backgroundColor: C.alloggio, borderRadius: '3px', padding: '1px 5px' }}>8.1</span>
                </div>
              </div>
            </div>
            <div className="pktp-features" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '4px 12px', marginTop: '8px', borderTop: `1px solid ${C.border}`, paddingTop: '8px' }}>
              {['Colazione a buffet inclusa','Wi-Fi gratuito','Smart TV satellite','Servizio in camera','Ascensore panoramico','Concierge 24h'].map((s, i) => (
                <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                  <span style={{ width: '4px', height: '4px', borderRadius: '50%', backgroundColor: C.alloggio, flexShrink: 0 }} />
                  <span className="pktp-feature-text" style={{ fontSize: '13px', color: C.text }}>{s}</span>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* RIGA 2: Servizi + Attività */}
        <div className="pktp-row">

          {/* SERVIZI */}
          <div className="pktp-cell pktp-cell-bl" style={{ padding: '14px 16px', borderRight: `2px solid ${C.border}` }}>
            <SegLabel colore={C.servizi} img="/images/servizi_icona.png" label="SERVIZI" />
            {[
              { nome: 'Collegamento aeroportuale A/R (RER B)', prezzo: '€ 32,00' },
              { nome: 'Paris Visite Card 5 giorni (metro illimitato)', prezzo: '€ 68,00' },
            ].map((item, i) => (
              <div key={i} className="pktp-list-row" style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '5px 0', borderBottom: i < 1 ? `1px solid ${C.border}` : 'none' }}>
                <span style={{ width: '5px', height: '5px', borderRadius: '50%', backgroundColor: C.servizi, flexShrink: 0 }} />
                <span className="pktp-list-text" style={{ flex: 1, fontSize: '16px', color: C.text }}>{item.nome}</span>
                <span style={{ fontSize: '11px', color: C.servizi, border: `1px solid ${C.servizi}`, borderRadius: '3px', padding: '1px 6px', fontWeight: 600, whiteSpace: 'nowrap' }}>dettagli</span>
                <span className="pktp-list-price" style={{ fontSize: '17px', fontWeight: 800, color: C.text, minWidth: '60px', textAlign: 'right' }}>{item.prezzo}</span>
              </div>
            ))}
          </div>

          {/* ATTIVITÀ */}
          <div className="pktp-cell" style={{ padding: '14px 16px' }}>
            <SegLabel colore={C.attivita} img="/images/attivita_icona.png" label="ATTIVITÀ" />
            {[
              { nome: 'Torre Eiffel — accesso al vertice', prezzo: '€ 80,00' },
              { nome: 'Museo del Louvre con audioguida', prezzo: '€ 54,00' },
              { nome: 'Crociera sulla Senna "Bateaux Mouches"', prezzo: '€ 38,00' },
              { nome: 'Palazzo di Versailles con skip-the-line', prezzo: '€ 72,00' },
              { nome: 'Moulin Rouge — spettacolo serale', prezzo: '€ 210,00' },
              { nome: 'Tour Montmartre + Basilica del Sacro Cuore', prezzo: '€ 42,00' },
              { nome: 'Degustazione vini e formaggi francesi', prezzo: '€ 24,00' },
            ].map((item, i, arr) => (
              <div key={i} className="pktp-list-row" style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '5px 0', borderBottom: i < arr.length - 1 ? `1px solid ${C.border}` : 'none' }}>
                <span style={{ width: '5px', height: '5px', borderRadius: '50%', backgroundColor: C.attivita, flexShrink: 0 }} />
                <span className="pktp-list-text" style={{ flex: 1, fontSize: '16px', color: C.text, lineHeight: 1.3 }}>{item.nome}</span>
                <span style={{ fontSize: '11px', color: C.attivita, border: `1px solid ${C.attivita}`, borderRadius: '3px', padding: '1px 6px', fontWeight: 600, whiteSpace: 'nowrap', flexShrink: 0 }}>dettagli</span>
                <span className="pktp-list-price" style={{ fontSize: '17px', fontWeight: 800, color: C.text, minWidth: '60px', textAlign: 'right', flexShrink: 0 }}>{item.prezzo}</span>
              </div>
            ))}
          </div>
        </div>

      </div>

      {/* 91% MATCH */}
      <div className="pktp-footer" style={{ padding: '10px 24px', backgroundColor: C.dark, display: 'flex', alignItems: 'center', gap: '12px' }}>
        <span className="pktp-footer-pct" style={{ fontSize: '20px', fontWeight: 900, color: C.white, textDecoration: 'underline', textDecorationColor: C.trasporto, textDecorationThickness: '3px' }}>91%</span>
        <span className="pktp-footer-text" style={{ fontSize: '16px', color: C.white, fontWeight: 400 }}>In linea con il tuo profilo e le tue aspettative</span>
      </div>

    </div>
  );
}

function SegLabel({ colore, img, label }) {
  return (
    <div className="pktp-seglabel" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '7px', marginBottom: '12px' }}>
      <img src={img} alt={label} className="pktp-seglabel-icon" style={{ height: '18px', objectFit: 'contain' }} />
      <span className="pktp-seglabel-text" style={{ fontSize: '13px', fontWeight: 900, color: colore, textTransform: 'uppercase', letterSpacing: '0.12em' }}>{label}</span>
    </div>
  );
}

function VologRow({ direz, oraPart, cittaPart, durata, tipo, oraArr, cittaArr, prezzo, colore }) {
  return (
    <div>
      <div className="pktp-volo-badge-row" style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '5px' }}>
        <span style={{ backgroundColor: colore, color: '#fff', fontSize: '11px', fontWeight: 800, padding: '2px 7px', borderRadius: '3px', letterSpacing: '0.04em' }}>{direz}</span>
        <span style={{ color: colore, fontSize: '13px' }}>✈</span>
        <span style={{ marginLeft: 'auto', fontSize: '11px', color: colore, border: `1px solid ${colore}`, borderRadius: '3px', padding: '1px 6px', fontWeight: 600 }}>dettagli</span>
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
        <div style={{ textAlign: 'left' }}>
          <div className="pktp-volo-time" style={{ fontSize: '17px', fontWeight: 900, color: C.text, lineHeight: 1 }}>{oraPart}</div>
          <div className="pktp-volo-city" style={{ fontSize: '13px', color: C.text, textTransform: 'uppercase', letterSpacing: '0.06em', marginTop: '1px' }}>{cittaPart}</div>
        </div>
        <div style={{ flex: 1, textAlign: 'center', minWidth: '60px' }}>
          <div className="pktp-volo-mid" style={{ fontSize: '13px', fontWeight: 700, color: C.text }}>{durata}</div>
          <div style={{ height: '1px', backgroundColor: C.border, margin: '2px 0', position: 'relative' }}>
            <span style={{ position: 'absolute', right: 0, top: '-5px', color: C.text, fontSize: '11px' }}>▶</span>
          </div>
          <div className="pktp-volo-mid" style={{ fontSize: '13px', color: C.text }}>{tipo}</div>
        </div>
        <div style={{ textAlign: 'left' }}>
          <div className="pktp-volo-time" style={{ fontSize: '17px', fontWeight: 900, color: C.text, lineHeight: 1 }}>{oraArr}</div>
          <div className="pktp-volo-city" style={{ fontSize: '13px', color: C.text, textTransform: 'uppercase', letterSpacing: '0.06em', marginTop: '1px' }}>{cittaArr}</div>
        </div>
        <div className="pktp-volo-price" style={{ fontWeight: 900, fontSize: '17px', color: C.text, marginLeft: 'auto' }}>{prezzo}</div>
      </div>
    </div>
  );
}
